import { useQuery } from "@tanstack/react-query";
import { overviewGroupByOptionsQueryOptions } from "@/lib/queries/overview.queries";

interface UseOverviewGroupByOptionsResult {
  options: string[];
  isLoading: boolean;
  /** True when the job failed or the poll budget elapsed — never a silent empty list. */
  isError: boolean;
}

/**
 * Distinct values of the selected Group By dimension for the My-Brand sub-filter.
 *
 * The gateway answers `200 { data }` on a warm cache and `202 { correlationId }` on a
 * cold miss; `fetchAmberOptions` resolves both inside the `queryFn`, so the poll is no
 * longer a state machine here. It throws on FAILED and on poll-budget exhaustion, which
 * is why `isError` exists: returning `[]` for a failed BigQuery job would render an empty
 * dropdown indistinguishable from a dimension that genuinely has no values.
 */
export function useOverviewGroupByOptions(
  tenantId: string | null,
  groupBy: string,
  dateRange: string,
  window: { startDate: string; endDate: string },
): UseOverviewGroupByOptionsResult {
  const { data, isLoading, isError } = useQuery(
    overviewGroupByOptionsQueryOptions(tenantId, groupBy, dateRange, window),
  );

  return { options: data ?? [], isLoading, isError };
}
